import { ACCOUNTANT_DASHBOARD_PAGE_URL, ANNOUNCEMENTS_PAGE_URL, PREFERENCES_ACCOUNT_PAGE_URL } from '@/api/core/links';
import { Navigate, Route, Routes } from 'react-router-dom';
import AccountantSpaceDashboardPage from '@/app/pages/accountant-space/AccountantSpaceDashboardPage';
import { MasterLayout } from '@/_metronic/layout/MasterLayout';
import SuspensedView from '@/app/components/layout/SuspensedView';
import AnnouncementWrapper from '@/app/pages/notifications/announcements/AnnouncementWrapper';
import UserPreferencesWrapper from '@/app/pages/preferences/user-session/UserPreferencesWrapper';

const AccountantRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route index element={<Navigate to={ACCOUNTANT_DASHBOARD_PAGE_URL} />} />
        <Route
          element={
            <SuspensedView>
              <AccountantSpaceDashboardPage />
            </SuspensedView>
          }
          path={ACCOUNTANT_DASHBOARD_PAGE_URL}
        />
        <Route
          element={
            <SuspensedView>
              <UserPreferencesWrapper />
            </SuspensedView>
          }
          path={PREFERENCES_ACCOUNT_PAGE_URL}
        />
        <Route
          element={
            <SuspensedView>
              <AnnouncementWrapper />
            </SuspensedView>
          }
          path={`${ANNOUNCEMENTS_PAGE_URL}/*`}
        />
        <Route element={<Navigate to="/error/404" />} path="*" />
      </Route>
    </Routes>
  );
};

export default AccountantRoutes;
